import { isNil } from '../../utils';
import { MobizMembership } from '../interfaces/mobiz-membership.interface';
import { SerializableObject } from './serializable-object';


/**
 * The ERP user information.
 */
export class UserInfo extends SerializableObject {
  public userId: string;
  public name: string;
  public ssn: string;
  public email: string;
  public employeeId: string;
  public mobizInfo: MobizMembership;
  public role: string;

  public buildFromJSON(json: Object) {
    super.buildFromJSON(json);
  }

  public isErpUserNew(): boolean {
    return isNil(this, 'mobizInfo');
  }

  public isErpUserInvited(): boolean {
    return !isNil(this, 'mobizInfo.invite');
  }

  public hasErpUserDkAccount(): boolean {
    return !isNil(this, 'mobizInfo.membership');
  }
}
